import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import LeadLabel from "../../components/Admin/LeadLabel"

const LdLabel = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Lead Labels | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <LeadLabel />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default LdLabel
